export default {
    "alertLog_driver": "Conductor",
    "alertLog_landmark": "Punto de Referencia",
    "alertLog_alertName": "Alerta",
    "alertLog_unitTime": "Hora de Unidad",
    "alertLog_address": "Dirección",
    "alertLog_vehicleName": "Nombre de Vehículo",
    "alertLog_currentTime": "Hora Actual"
}